import { useState, useEffect, MouseEventHandler } from "react";

export const BtnPageTop = () => {
  const [hide, setHide] = useState(true)

  // 1回だけ実行
  useEffect(() => {
    const scrollListener = () => {
      setHide(window.scrollY < 800)
    }
    window.addEventListener('scroll', scrollListener)

    return function cleanUp() {
      window.removeEventListener('scroll', scrollListener)
    }
  }, [])

  // 400msかけてページトップまで移動
  const tick = 20 // ms
  const animate: MouseEventHandler = (e) => {
    e.preventDefault()

    let y = window.scrollY / (400 / tick)
    const id = setInterval(() => {
      const nextY = window.scrollY - y
      window.scrollTo(0, nextY)
      if (nextY <= 0) clearInterval(id)
    }, tick)
  }

  // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
  return <div id="btnPgTop" className={`${hide ? '' : 'showBtn'}`} onClick={animate}><a href="#"></a></div>
}